import request from "@/utils/request";
const projectName = "/api/blade-platform";
//获取外部访问链接
export const detail = params => {
    return request({
        url: `${projectName}/platformsystemaccesslink/detail`,
        method: "get",
    });
};
//修改外部访问链接
export const update = params => {
  return request({
      url: `${projectName}/platformsystemaccesslink/update`,
      method: "post",
      data:params
  });
};
//获取外观显示配置
export const detailWG = params => {
    return request({
        url: `${projectName}/platformapplyguiselogo/detail`,
        method: "get",
    });
};
//修改外观显示配置
export const submit = params => {
    return request({
        url: `${projectName}/platformapplyguiselogo/submit`,
        method: "post",
        data:params
    });
};
//==============================一网通办V1.0.0对应接口
//获取外观显示配置
export const platformapplyguiselogoDetail = params => {
    return request({
        url: `${projectName}/platformapplyguiselogo/detail`,
        method: "get",
    });
};
//修改外观显示配置
export const platformapplyguiselogoUpdate = params => {
    return request({
        url: `${projectName}/platformapplyguiselogo/update`,
        method: "post",
        data:params
    });
};
